export const DEFAULT_BACKOFF = {
    baseDelayMs: 1000,
    factor: 2,
    maxDelayMs: 30_000,
    maxAttempts: 5,
    jitter: 0.5,
    random: Math.random,
};
export function resolveBackoff(options) {
    return { ...DEFAULT_BACKOFF, ...options };
}
/**
 * Computes the delay (ms) before retry attempt `attempt` (1-based: the delay before
 * the *next* try after `attempt` failures so far). Exponential growth capped at
 * `maxDelayMs`, then full jitter applied: uniformly sampled from
 * `[delay * (1 - jitter), delay * (1 + jitter)]`, clamped to be non-negative.
 */
export function computeBackoffDelay(attempt, options) {
    const { baseDelayMs, factor, maxDelayMs, jitter, random } = resolveBackoff(options);
    const raw = baseDelayMs * Math.pow(factor, Math.max(0, attempt - 1));
    const capped = Math.min(raw, maxDelayMs);
    const jitterSpan = capped * jitter;
    const low = Math.max(0, capped - jitterSpan);
    const high = capped + jitterSpan;
    return low + random() * (high - low);
}
//# sourceMappingURL=backoff.js.map